import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Button from 'src/components/button';
import { toast } from 'react-toastify';
import Toast from 'src/components/toast';

import styles from './Styles.module.scss';
class DeleteSkillView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

  }

  _handleDeleteClick() {
    this.props.deleteSkill(this.props.item.id).then(() => {
      if (this.props.onDeletion) {
        this.props.onDeletion(this.props.item.id);
        toast(
          <Toast.Sucess
            message={`Skill ${this.props.item.name} deleted successfully`}
          />,
          {
            autoClose: 3000,
          }
        );
      }
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <Col sm={8} className={styles.column}>
            <div className={styles.heading}>deleting</div>
            <div className={styles.label}>
              {this.props.item &&
                <h2 className={styles.skillName}>{`${this.props.item.name} `}</h2>}
            </div>

            <p className={styles.description}>
              Are you sure you would like to delete the selected skill?
            </p>
          </Col>
        </Row>
        <Row>
          <div className={styles.buttonTray}>

            <Button
              text={this.props.deleting ? `Deleting...` : "Confirm"}
              disabled={this.props.deleting}
              variant='primary'
              onClick={() => { this._handleDeleteClick() }}

            />

            <Button
              text="Cancel"
              disabled={this.props.deleting}
              onClick={() => { this._handleCancelClick() }}
            />
          </div>

        </Row>
      </div>
    );
  }
}
export default DeleteSkillView;